import { ListItemText, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import axios from "axios";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState
} from "react";

const Autocomplete = forwardRef(
  ({ selectedItemData, selectedDoctorId }, ref) => {
    // const Autocomplete = ({selectedItemData, selectedDoctorId}) => {
    const [selectedIndex, setSelectedIndex] = React.useState(1);
    const [doctorListData, setDoctorListData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isShowList, setIsShowlist] = useState(false);
    const [selectedLabel, setSelectedLabel] = useState("");
    const [selectedItem, setSelectedItem] = useState({ label: "", value: "" });

    useEffect(() => {
      setIsShowlist(false);
    }, [selectedItem]);
    // UseRef
    useImperativeHandle(ref, () => ({
      getAlert() {
        alert("alert form Doctor List auto");
      },
      resetFormData,
    }));
    // UseRef //
    const handleListItemClick = (event, index, item) => {
      setSelectedIndex(index);
      console.log(item);
      setSelectedLabel(item.label);
      setSelectedItem(item);
      setIsShowlist(false);
      selectedItemData(item);
    };
    const [selectedOption, setSelectedOption] = useState({});

    const handleItemSelect = () => {
      console.log("hanlde Item Select");
    };

    const getDoctorListFromLocalStorage = () => {
      const doctorListLocal = localStorage.getItem("doctorList"); // get localStorage by serviceList key
      if (doctorListLocal) {
        // doctorList key exist
        const newDoctorList = JSON.parse(doctorListLocal);
        setDoctorListData(newDoctorList); // convert localStoreage  string value to object & update state
        // console.log("newDoctorList", newDoctorList);
        // Default Selection

        if (newDoctorList.length === 1) {
          setSelectedItem(newDoctorList[0]);
        }
      } else {
        // service list key dow not exist so run axios to get data from remote host
        getDoctorList();
      }
    };
    const getDoctorList = () => {
      setLoading(true);
      axios
        .get(`/dentrino-doctors-manager`)
        .then((response) => {
          setLoading(false);
          const doctorList = response.data;
          const newDoctorList = [];
          doctorList.map((item) =>
            newDoctorList.push({ value: item.id, label: item.doctor_name })
          );
          localStorage.setItem("doctorList", JSON.stringify(newDoctorList)); // stringify & set to local storage
          if (newDoctorList.length === 1) {
            setSelectedItem(newDoctorList[0]);
          }
          setDoctorListData(newDoctorList);
        })
        .catch((error) => {
          setLoading(false);
          console.error(error);
        })
        .finally(() => console.log);
    };
    const handleOnBlur = () => {
      setTimeout(function(){
        setIsShowlist(false)
      }, 200);
    };
    const resetFormData = () => {
      setSelectedItem({ label: "", value: "" });
    };

    useEffect(() => {
      getDoctorListFromLocalStorage();
    }, []);

    useEffect(() => {
      if (doctorListData.length > 0) {
        const findItem = doctorListData.find(
          (item) => item.value === selectedDoctorId
        );
        if (findItem) {
          console.log("findItem -", findItem);
          selectedItemData({ ...findItem });
          setSelectedLabel(findItem);
          setSelectedItem(findItem);
        }
      }

      // doctorListData.map(item=>{
      //   if
      //   selectedItemData(item);
      // })
    }, [selectedDoctorId, doctorListData]);
    return (
      <>
        <div style={{ position: "relative" }}>
          <TextField
            autoComplete="new-password"
            label="Select Doctor"
            value={selectedItem.label}
            onClick={() => setIsShowlist(true)}
            onBlur={handleOnBlur}
          />
          {/* <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "white", position:"absolute" , zIndex:2 , border:1, borderRadius: 1, padding:1}}
        >
          {[1, 2, 3].map((value) => (
            <ListItem
              key={value}
              disableGutters
              secondaryAction={
                <IconButton>
                  <CommentIcon />
                </IconButton>
              }
            >
              <ListItemText  primary={`Line item ${value}`} onClick={handleItemSelect} />
            </ListItem>
          ))}
        </List> */}
          <Box
            sx={{
              width: "100%",
              maxWidth: 360,
              bgcolor: "background.paper",
              position: "absolute",
              zIndex: 2,
              display: isShowList ? "block" : "none",
            }}
          >
            <List component="nav" aria-label="main mailbox folders">
              {doctorListData.map((item, index) => (
                <ListItemButton
                  key={index}
                  selected={selectedIndex === index}
                  onClick={(event) => handleListItemClick(event, index, item)}
                >
                  {/* <ListItemIcon>
                      <InboxIcon />
                    </ListItemIcon> */}
                  <ListItemText primary={item.label} />
                </ListItemButton>
              ))}
            </List>
          </Box>
        </div>
      </>
    );
  }
);

export default Autocomplete;
